let nextUploadId = 0;
// eslint-disable-next-line import/prefer-default-export
export function getNextUploadId(): number {
  nextUploadId += 1;
  return nextUploadId;
}
